import { useEffect, useRef } from 'react'
import { fetchDeployedBuildTime, isNewVersionAvailable } from '@/utils/versionCheck'

export function useVersionCheck(onNewVersion: () => void): void {
  const notifiedRef = useRef(false)
  const onNewVersionRef = useRef(onNewVersion)
  onNewVersionRef.current = onNewVersion

  useEffect(() => {
    const check = async () => {
      if (notifiedRef.current) return
      const deployed = await fetchDeployedBuildTime()
      if (isNewVersionAvailable(deployed)) {
        notifiedRef.current = true
        onNewVersionRef.current()
      }
    }

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') void check()
    }

    document.addEventListener('visibilitychange', handleVisibility)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibility)
    }
  }, [])
}
